import qs from 'qs';
import userAuthManager from 'utils/flowGate';
import { invitations } from 'services/api';

const triggerActivationRedirect = async history => {
  const query = await qs.parse(history.location.search, { ignoreQueryPrefix: true });
  const { activation_id, activation_code } = query;
  if (activation_id && activation_code) {
    try {
      const currentSession = await userAuthManager.querySessionStatus();

      if (currentSession) {
        await userAuthManager.signoutRedirect();
        return userAuthManager.signinRedirect({
          prompt: 'activate',
          extraQueryParams: { activation_id, activation_code },
        });
      }
    } catch (e) {
      return userAuthManager.signinRedirect({
        prompt: 'activate',
        extraQueryParams: { activation_id, activation_code },
      });
    }
  }

  return userAuthManager.signinRedirect();
};

const triggerActivation = async (n = 3) => {
  try {
    const response = await invitations.admin();
    return response;
  } catch (err) {
    if (n === 1) {
      console.error(err);
      return userAuthManager.signoutRedirect();
    }
    return triggerActivation(n - 1);
  }
};

const authUtil = {
  triggerActivationRedirect,
  triggerActivation,
};

export default authUtil;
